import settings from '../settings';

import $ from 'jquery';

export default class Preview {
  calculators;

  create($preview, link, title, description, image) {
    var url = 'https://api.embed.ly/1/extract?wmode=opaque&words=50&maxwidth=150&meta_images=1&key=' + settings.preview_key + '&urls=' + encodeURIComponent(link);

    if (title != null && title.length > 0) {
        $preview.find('.article-preview__title').text(title.substr(0, 100) + '...');
    }

    if (description != null && description.length > 0) {
        $preview.find('.article-preview__description').text(description.substr(0, 100) + '...');
    }

    if (image != null && image.length > 0) {
        $preview.find('.article-preview__img').attr('src', image);
    }

    // All present. bypass preview tool
    if (title != null && title.length > 0 && description != null && description.length > 0 && image != null && image.length > 0) {
        $preview.find('.article-preview__img').show();
        $preview.find('.article-preview__url').text(link);
        $preview.removeClass('visually-hidden').show();
        return;
    }

    $.ajax({
      url: url,
      dataType: 'jsonp',
      success: function(data) {
        if (data[0].type != 'error') {
          if (title == null || title.length == 0) {
            if (data[0].title != null) {
                $preview.find('.article-preview__title').text(data[0].title.substr(0, 100)+'...');
            }
          } else {
            $preview.find('.article-preview__title').text(title.substr(0, 100) + '...');
          }
          if (description == null || description.length == 0) {
            if (data[0].description != null) {
                $preview.find('.article-preview__description').text(data[0].description.substr(0, 100)+'...');
            }
          } else {
            $preview.find('.article-preview__description').text(description.substr(0, 100) + '...');
          }
          $preview.find('.article-preview__url').text(data[0].original_url);
          if (image != null && image.length > 0) {
              $preview.find('.article-preview__img').attr('src', image);
              $preview.find('.article-preview__img').show();
          } else if (data[0].images.length > 0) {
            $preview.find('.article-preview__img').attr('src', data[0].images[0].url);
            $preview.find('.article-preview__img').show();
          } else {
            $preview.find('.article-preview__img').hide();
          }
          $preview.removeClass('visually-hidden').show();
        }
      }
    });
  }

  generate_preview(alllinks, $elem, $preview) {
    var links = "";
    function removeEmojis (string) {
        var regex = /(?:[\u2700-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff]|[\u0023-\u0039]\ufe0f?\u20e3|\u3299|\u3297|\u303d|\u3030|\u24c2|\ud83c[\udd70-\udd71]|\ud83c[\udd7e-\udd7f]|\ud83c\udd8e|\ud83c[\udd91-\udd9a]|\ud83c[\udde6-\uddff]|\ud83c[\ude01-\ude02]|\ud83c\ude1a|\ud83c\ude2f|\ud83c[\ude32-\ude3a]|\ud83c[\ude50-\ude51]|\u203c|\u2049|[\u25aa-\u25ab]|\u25b6|\u25c0|[\u25fb-\u25fe]|\u00a9|\u00ae|\u2122|\u2139|\ud83c\udc04|[\u2600-\u26FF]|\u2b05|\u2b06|\u2b07|\u2b1b|\u2b1c|\u2b50|\u2b55|\u231a|\u231b|\u2328|\u23cf|[\u23e9-\u23f3]|[\u23f8-\u23fa]|\ud83c\udccf|\u2934|\u2935|[\u2190-\u21ff])/g;
        if(string){
            return string.replace(regex, '');
        }
        return "";
    }
    if(typeof alllinks === "string"){
      links = removeEmojis(alllinks);
    }else{
      links = alllinks;
    }
    
    if (links && links.length) {

      var link = links[links.length - 1];
      if(link[0] != "@"){
        var url = 'https://api.embed.ly/1/extract?wmode=opaque&words=50&maxwidth=150&meta_images=1&key=' + settings.preview_key + '&urls=' + encodeURIComponent(link);

        $.ajax({
          url: url,
          dataType: 'jsonp',
          success: function(data) {
            if (data[0].type != 'error') {
              if (data[0].title == null) {
                data[0].title = '';
              }
              if (data[0].description == null) {
                data[0].description = '';
              }
              $elem.find('.article-preview__title').text(data[0].title.substr(0, 100)+'...').data('original-title', data[0].title.substr(0, 100)+'...');
              $elem.find('.article-preview__description').text(data[0].description.substr(0, 100)+'...').data('original-description', data[0].description.substr(0, 100)+'...');
              $elem.find('.article-preview__url').text(data[0].original_url);
              if (data[0].images.length > 0) {
                $elem.find('.article-preview__img').attr('src', data[0].images[0].url).data('original-image', data[0].images[0].url);
                $elem.find('.article-preview__img').show();
              } else {
                $elem.find('.article-preview__img').hide();
              }
              $preview.removeClass('visually-hidden').show();
            } else {
              // An error occurred
              if (links.length === 1) {
                // If there are no other valid links, remove the preview
                $preview.hide();
              }
            }
          }
        });
      }else{
        $preview.hide();
      }

      
    } else {
      $preview.hide();
    }
  }

  set_title(title, $elem) {
    $elem.find('.article-preview__title').text(title.substr(0, 100)+'...');
  }

  set_description(description, $elem) {
    $elem.find('.article-preview__description').text(description.substr(0, 100)+'...');
  }
}
